module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Regular.f97524d1.woff2";